import React from "react";
import {
    Button,
    Dialog,
    DialogHeader,
    DialogBody,
    DialogFooter,
} from "@material-tailwind/react";
import { useFormContext } from "react-hook-form";

export default function DeleteQuestionDialog({
    showDialog,
    deleteIndex,
    removeCallback,
    setDeleteArrayState,
    onClose,
    handleClose,
}) {
    const { getValues } = useFormContext();

    const onConfirmDelete = () => {
        // Read the store at click time: the delete index refers to the
        // current questions array, and a render-time snapshot could be a
        // keystroke behind.
        const question_id = getValues("questions")?.[deleteIndex]?.id;
        if (question_id) {
            setDeleteArrayState((arr) => [...arr, question_id]);
        }
        removeCallback(deleteIndex);
        handleClose();
        onClose();
    };

    const closeOnly = () => {
        handleClose();
        onClose();
    };

    return (
        <Dialog open={showDialog} handler={handleClose} className="dialog">
            <DialogHeader className="dialog__header">
                <p>Delete Question?</p>
            </DialogHeader>
            <DialogBody className="dialog__body">
                {
                    "Are you sure you want to do this? It will permanently remove the selected question from your survey."
                }
            </DialogBody>
            <DialogFooter className="dialog__footer">
                <Button
                    type="button"
                    variant="filled"
                    className="btn btn--secondary"
                    onClick={() => closeOnly()}
                >
                    Cancel
                </Button>
                <Button
                    type="button"
                    className="btn btn--primary"
                    variant="filled"
                    onClick={() => onConfirmDelete()}
                >
                    Delete
                </Button>
            </DialogFooter>
        </Dialog>
    );
}
